import { Button, ButtonVariant } from '@synoptic/ui-kit/button/button.js';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { CheckIcon } from '@synoptic/ui-kit/icons/react/check.js';
import { CopyIcon } from '@synoptic/ui-kit/icons/react/copy.js';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import clsx from 'clsx';
import { useState } from 'react';
import { copyButton } from './copy-button.css';

export const CopyButton = ({
  text,
  title,
  className,
}: {
  text: string;
  title: string;
  className?: string;
}) => {
  const toast = useToast();
  return (
    <Button
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
          e.preventDefault();
          e.stopPropagation();
          await navigator.clipboard.writeText(text);
          toast.success({
            title: 'Stream id copied to clipboard',
            duration: 1000,
          });
        } catch (error) {
          console.error('Failed to copy to clipboard:', error);
          toast.error({
            title: 'Failed to copy to clipboard',
            subTitle: 'Please try again',
          });
        }
      }}
      className={clsx(copyButton, className)}
      variant="outline"
      size="small"
    >
      {title}
    </Button>
  );
};

export const CopyIconButton = ({
  text,
  className,
  variant = 'secondary',
}: {
  text: string;
  className?: string;
  variant?: ButtonVariant;
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
    }
  };

  return (
    <IconButton
      onClick={handleCopy}
      rounded={false}
      aria-label={copied ? 'Code copied' : 'Copy code'}
      className={className}
      variant={variant}
      size="small"
    >
      {copied ? <CheckIcon /> : <CopyIcon />}
    </IconButton>
  );
};
